import { render } from "./selectLocation.vue?vue&type=template&id=dbd8333a&scoped=true"
import script from "./selectLocation.vue?vue&type=script&lang=js"
export * from "./selectLocation.vue?vue&type=script&lang=js"

import "./selectLocation.vue?vue&type=style&index=0&id=dbd8333a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbd8333a"]])

export default __exports__